'use strict';

exports.__esModule = true;
exports.default = {
  CONNECTED: 'connected',
  AUTHORIZATION_EXPIRED: 'authorization_expired',
  NOT_AUTHORIZED: 'not_authorized',
  UNKNOWN: 'unknown'
};
//# sourceMappingURL=LoginStatus.js.map